module.exports = __webpack_public_path__ + "img/hp-logo-512.21f7099f.png";